import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {setCurrentUserMix} from 'actions/index.js';

class UserMixesComponent extends Component {
    onClickMix(mix) {
        this.props.setCurrentUserMix(mix.getJson());
    }

    onClickDeleteMix(e, mix) {
        e.stopPropagation();
        this.props.onClickDeleteMix(mix);
    }

    render() {
        return (
            <div>
              {this.props.mixes.map(
                  mix =>
                      <div
                            onClick={() => this.onClickMix(mix)}
                            className="user-mix">
                            {mix.name}
                            <ConditionedComponent condition={this.props.isEditing}>
                                  <div onClick={(e) => this.onClickDeleteMix(e, mix)} className="delete-button">x</div>
                            </ConditionedComponent>
                      </div>)}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCurrentUserMix: (currentMix) => dispatch(setCurrentUserMix(currentMix)),
    };
};

export default connect(null, mapDispatchToProps)(UserMixesComponent);
